export const ACCOUNT_COOKIE = 'brbdrvwacc'

export const DEFAULT_OPTIONS = {
  expires: 60 * 60 * 2.5 * 1000,
  sameSite: true,
  path: '/'
}
